import { visserApi } from "./visserApi";
const getAllArticals = async () => {
    return visserApi.get('Article/GetArticleDropdown');
};
const getArticleById = (articleId) => {
    return visserApi.get(`Article/GetArticleById/${articleId}`);
};
const getWorkOrdersListWithClientAsync = async (workOrderNumber) => {
    return await visserApi.get(`Workorder/GetSearchableWorkOrdersList/${workOrderNumber}`);
};
const CreateOrderLine = (orderLineDto) => {
    return visserApi.post('OrderLine/Create', orderLineDto);
};
const UpdateOrderLine = (Id, orderLineDto) => {
    return visserApi.put(`OrderLine/Update/${Id}`, orderLineDto);
};
const getAllorderLinesByOrderID = (orderId) => {
    return visserApi.get(`OrderLine/GetAllOrderLinesByOrderId/${orderId}`);
};
const getOrderLineByID = (Id) => {
    return visserApi.get(`OrderLine/GetOrderLineByID/${Id}`);
};
const deleteOrderLine = async (id) => {
    return await visserApi.delete(`OrderLine/Delete/${id}`);
};
const recievedAllOrderLines = (orderId) => {
    return visserApi.get(`OrderLine/RecievedAllOrderLines/${orderId}`);
};
const removeWorkOrderIdLinkedWithOrderLines = async (id) => {
    return await visserApi.get(`OrderLine/RemoveWorkOrderIdLinkedWithOrderLines/${id}`);
};
const updateBulkOrderLine = async (updateBulkOrderLine) => {
    return await visserApi.put(`OrderLine/UpdateBulkOrderLine`, updateBulkOrderLine);
};
const OrderLineApi = {
    getAllArticals,
    getArticleById,
    getWorkOrdersListWithClientAsync,
    CreateOrderLine,
    UpdateOrderLine,
    getAllorderLinesByOrderID,
    getOrderLineByID,
    deleteOrderLine,
    recievedAllOrderLines,
    removeWorkOrderIdLinkedWithOrderLines,
    updateBulkOrderLine
};
export default OrderLineApi;
